import { render, staticRenderFns } from "./PayrollTypeEditor.vue?vue&type=template&id=b50f0138"
import script from "./PayrollTypeEditor.vue?vue&type=script&lang=js"
export * from "./PayrollTypeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports